module.exports = __webpack_public_path__ + "img/predio-comercial.e034356c.svg";